module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g7Hhb"))).then(() => parcelRequire('ljYL6'));